<template>
  <div v-show="logoImage && logoImage.length" class="benefit-logo-badges" :class="{ 'benefit-logo-badges--large': large }">
    <div v-for="logo in logoImage" :key="logo.id" class="benefit-logo-badge">
      <img :src="logo.attributes.ext ? getAssetUrl(logo.attributes.url) : null" :alt="logo.attributes.name" class="benefit-logo-img" />
    </div>
  </div>
</template>

<script>
// Mixins
import ViewMixin from "@/mixins/viewMixin"

export default {
  mixins: [ViewMixin],
  name: 'BenefitLogoBadges',
  props: {
    logoImage: [],
    large: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../styles/vars.less";

.benefit-logo-badges {
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 10px;

  @media screen and (min-width: @phone) {
    &--large {
      bottom: 60px;
      right: 60px;
      gap: 24px;

      .benefit-logo-badge {
        width: 100px;
        height: 100px;
        padding: 12px;
      }
    }
  }
}

.benefit-logo-badge {
  width: 50px;
  height: 50px;
  padding: 6px;
  background-color: @white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.benefit-logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>